import { render, staticRenderFns } from "./ConfiguracaoCobrancaTabela.vue?vue&type=template&id=5d2a5e90"
import script from "./ConfiguracaoCobrancaTabela.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoCobrancaTabela.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoCobrancaTabela.vue?vue&type=style&index=0&id=5d2a5e90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports